export interface Category {
  slug: string;
  name: string;
  short: string;
  description: string;
  cover: string;
  tone: 'primary' | 'accent' | 'secondary';
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'yunying-neimu',
    name: '运营内幕',
    short: '产品与业务背后的真实运转方式',
    description:
      '拆解平台的产品机制、增长节奏与商业设计，包括会员体系、补贴策略、定价逻辑与内容分发规则，帮助你理解一个产品为什么这样做。',
    cover:
      'https://readdy.ai/api/search-image?query=dark%20editorial%20desk%20scene%20with%20analytics%20charts%20printed%20on%20warm%20paper%2C%20magnifying%20glass%20and%20pen%2C%20moody%20amber%20lighting%2C%20no%20people%2C%20cinematic%20investigative%20atmosphere&width=720&height=480&seq=cat-yunying-01&orientation=landscape',
    tone: 'primary',
    icon: 'ri-radar-line',
  },
  {
    slug: 'laoban-beijing',
    name: '老板背景',
    short: '创始人与管理层的公开履历',
    description:
      '整理创始人及核心管理团队的公开职业经历、教育背景与资本关系，标注可查证的股权变更与任职时间线，尽量还原决策风格的形成过程。',
    cover:
      'https://readdy.ai/api/search-image?query=minimal%20dark%20boardroom%20interior%20with%20empty%20leather%20chairs%20and%20a%20single%20desk%20lamp%2C%20warm%20amber%20tone%2C%20editorial%20photography%2C%20no%20people%2C%20quiet%20authoritative%20mood&width=720&height=480&seq=cat-laoban-01&orientation=landscape',
    tone: 'accent',
    icon: 'ri-user-star-line',
  },
  {
    slug: 'yuangong-baoliao',
    name: '员工爆料',
    short: '来自一线的工作体验叙述',
    description:
      '收录一线员工关于招聘承诺、内部流程、协作方式与试用期评估的真实叙述，保留原始细节，同时标注核实程度与投稿时间。',
    cover:
      'https://readdy.ai/api/search-image?query=candid%20office%20corridor%20with%20glass%20walls%20and%20warm%20evening%20light%2C%20empty%20desks%20and%20notes%20on%20wall%2C%20editorial%20documentary%20style%2C%20no%20identifiable%20people%2C%20muted%20warm%20palette&width=720&height=480&seq=cat-baoliao-01&orientation=landscape',
    tone: 'secondary',
    icon: 'ri-megaphone-line',
  },
  {
    slug: 'bangong-huanjing',
    name: '办公环境',
    short: '工位、通勤与工作强度的细节',
    description:
      '关注办公场所的实际体验，包括工位密度、通勤时长、会议节奏、硬件配置与加班后的配套安排，这些往往是福利介绍里最容易被略过的部分。',
    cover:
      'https://readdy.ai/api/search-image?query=modern%20open%20plan%20office%20at%20dusk%20with%20rows%20of%20empty%20desks%2C%20warm%20ceiling%20lights%2C%20large%20windows%2C%20documentary%20editorial%20photography%2C%20no%20people%2C%20calm%20neutral%20tones&width=720&height=480&seq=cat-huanjing-01&orientation=landscape',
    tone: 'secondary',
    icon: 'ri-building-2-line',
  },
  {
    slug: 'caiyuan-neimu',
    name: '裁员内幕',
    short: '组织调整的节奏与话术',
    description:
      '记录组织调整从通知到落地的完整过程，梳理补偿方案的类型、协商解除的常见话术与时间线，帮助你在类似处境下提前做好准备。',
    cover:
      'https://readdy.ai/api/search-image?query=stack%20of%20sealed%20cardboard%20moving%20boxes%20beside%20an%20empty%20office%20chair%2C%20warm%20dim%20light%2C%20editorial%20still%20life%2C%20no%20people%2C%20melancholic%20amber%20tone&width=720&height=480&seq=cat-caiyuan-01&orientation=landscape',
    tone: 'primary',
    icon: 'ri-scissors-cut-line',
  },
  {
    slug: 'xinzi-jiufen',
    name: '薪资纠纷',
    short: '工资、绩效与加班费的争议',
    description:
      '围绕拖欠工资、绩效克扣、加班费与调休等常见争议，整理证据准备、沟通要点与劳动仲裁流程的实用信息，让维权不再无从下手。',
    cover:
      'https://readdy.ai/api/search-image?query=payslip%20documents%20calculator%20and%20pen%20on%20warm%20wooden%20table%2C%20soft%20directional%20light%2C%20editorial%20flat%20lay%20photography%2C%20no%20people%2C%20warm%20neutral%20palette&width=720&height=480&seq=cat-xinzi-01&orientation=landscape',
    tone: 'accent',
    icon: 'ri-money-cny-circle-line',
  },
];